<template>
  <Layout>
    <div>
      <h1>Change Password</h1>
      
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h3>Update Your Password</h3>
            </div>
            <div class="card-body">
              <form @submit.prevent="changePassword">
                <div class="form-group">
                  <label for="password">Current Password *</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="password" 
                    v-model="form.password"
                    required
                  >
                </div>
                
                <div class="form-group">
                  <label for="newpassword">New Password *</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="newpassword" 
                    v-model="form.newpassword"
                    required
                  >
                  <small class="form-text text-muted">
                    Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one number.
                  </small>
                </div>
                
                <div class="form-group">
                  <label for="renewpwd">Confirm New Password *</label>
                  <input 
                    type="password" 
                    class="form-control" 
                    id="renewpwd" 
                    v-model="form.renewpwd"
                    required
                    :class="{ 'is-invalid': form.renewpwd && form.newpassword !== form.renewpwd }"
                  >
                  <div v-if="form.renewpwd && form.newpassword !== form.renewpwd" class="invalid-feedback">
                    新密码和确认新密码不一致
                  </div>
                  <div v-else-if="form.renewpwd && form.newpassword === form.renewpwd" class="valid-feedback">
                    密码确认成功
                  </div>
                </div>
                
                <div class="password-strength" v-if="form.newpassword">
                  <h6>Password Strength:</h6>
                  <div class="progress mb-2">
                    <div 
                      class="progress-bar" 
                      :class="passwordStrengthClass"
                      :style="{ width: passwordStrength + '%' }"
                    ></div>
                  </div>
                  <small class="text-muted">{{ passwordStrengthText }}</small>
                </div>
                
                <div class="form-group">
                  <button type="submit" class="btn btn-primary btn-lg" :disabled="loading || !isFormValid">
                    {{ loading ? 'Updating...' : 'Update Password' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          <div class="card mt-3">
            <div class="card-body">
              <h5>Password Requirements</h5>
              <ul class="password-requirements">
                <li :class="{ 'text-success': form.newpassword.length >= 8 }">
                  <i :class="form.newpassword.length >= 8 ? 'fa fa-check' : 'fa fa-times'"></i>
                  At least 8 characters long
                </li>
                <li :class="{ 'text-success': hasUppercase }">
                  <i :class="hasUppercase ? 'fa fa-check' : 'fa fa-times'"></i>
                  Contains at least one uppercase letter
                </li>
                <li :class="{ 'text-success': hasLowercase }">
                  <i :class="hasLowercase ? 'fa fa-check' : 'fa fa-times'"></i>
                  Contains at least one lowercase letter
                </li>
                <li :class="{ 'text-success': hasNumber }">
                  <i :class="hasNumber ? 'fa fa-check' : 'fa fa-times'"></i>
                  Contains at least one number
                </li>
                <li :class="{ 'text-success': hasSpecialChar }">
                  <i :class="hasSpecialChar ? 'fa fa-check' : 'fa fa-times'"></i>
                  Contains at least one special character
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import {apiService} from '@/config/api'

export default {
  name: 'ChangePassword',
  components: {
    Layout
  },
  data() {
    return {
      form: {
        password: '',
        newpassword: '',
        renewpwd: ''
      },
      loading: false
    }
  },
  computed: {
    hasUppercase() {
      return /[A-Z]/.test(this.form.newpassword)
    },
    hasLowercase() {
      return /[a-z]/.test(this.form.newpassword)
    },
    hasNumber() {
      return /\d/.test(this.form.newpassword)
    },
    hasSpecialChar() {
      return /[!@#$%^&*(),.?":{}|<>]/.test(this.form.newpassword)
    },
    passwordStrength() {
      let strength = 0
      if (this.form.newpassword.length >= 8) strength += 20
      if (this.hasUppercase) strength += 20
      if (this.hasLowercase) strength += 20
      if (this.hasNumber) strength += 20
      if (this.hasSpecialChar) strength += 20
      return strength
    },
    passwordStrengthClass() {
      if (this.passwordStrength < 40) return 'bg-danger'
      if (this.passwordStrength < 80) return 'bg-warning'
      return 'bg-success'
    },
    passwordStrengthText() {
      if (this.passwordStrength < 40) return 'Weak'
      if (this.passwordStrength < 80) return 'Medium'
      return 'Strong'
    },
    isFormValid() {
      return this.form.password && 
             this.form.newpassword && 
             this.form.renewpwd &&
             this.form.newpassword === this.form.renewpwd &&
             this.passwordStrength >= 80
    }
  },
  methods: {
    async changePassword() {
      // 验证新密码和确认新密码是否一致
      if (this.form.newpassword !== this.form.renewpwd) {
        alert('新密码和确认新密码不一致，请重新输入')
        return
      }
      
      if (!this.isFormValid) {
        alert('请确保所有字段都已填写且新密码符合要求')
        return
      }
      
      this.loading = true
      try {
        const res = await apiService.auth.changePassword(this.form)
        if (res.data && res.data.code === 1) {
          alert('密码修改成功！')
        } else if (res.data && res.data.code === 0) {
          alert(res.data.msg)
        } else {
          alert('密码修改失败，请重试')
        }
        
        // 重置表单
        this.form = {
          password: '',
          newpassword: '',
          renewpwd: ''
        }
        
        // alert('密码修改成功！')
      } catch (error) {
        console.error('Password change failed:', error)
        alert('密码修改失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.form-group {
  margin-bottom: 1rem;
}

.btn-lg {
  padding: 12px 30px;
  font-size: 18px;
}

.password-strength {
  margin-top: 15px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.password-requirements {
  list-style: none;
  padding: 0;
}

.password-requirements li {
  margin-bottom: 8px;
  color: #666;
}

.password-requirements li i {
  margin-right: 8px;
  width: 16px;
}

.password-requirements li.text-success {
  color: #28a745 !important;
}

.password-requirements li.text-success i {
  color: #28a745;
}

.password-requirements li:not(.text-success) i {
  color: #dc3545;
}

/* 验证提示样式 */
.invalid-feedback {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.valid-feedback {
  display: block;
  color: #28a745;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-control.is-valid {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
</style> 